// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-player-icon-primary{color:#fff;background-color:#57abf0}.video-player-btn:hover .video-player-icon-primary{color:#fff;background-color:#57abf0;box-shadow:0 12px 15px rgba(140,152,164,.1);transform:scale(1.1)}.video-player-icon-pill{width:100%;min-width:13rem;height:100%;padding:.75rem 1rem;border-radius:3.125rem;font-size:1rem;font-weight:600}", ""]);
// Exports
module.exports = exports;
